<script>
  import { onMount, createEventDispatcher, afterUpdate, tick } from 'svelte';
  import { performFollowUpSearch } from '../services/searchService';
  import { currentSearchThreadId, user, history } from '../stores/stores';
  import { get } from 'svelte/store';
  import { toast } from '@zerodevx/svelte-toast'
  import {t} from '../services/translation/translationService.js';

  export let darkened = false;
  
  let query = '';
  let inputElement;
  const dispatch = createEventDispatcher();
  
  let searchType = 'basic';
  onMount(() => {
    inputElement.focus();
  });
  
  let prevThreadId = null;
  
  afterUpdate(() => {
    const currentThreadId = get(currentSearchThreadId);
    if (currentThreadId !== prevThreadId) {
      prevThreadId = currentThreadId;
    }
  });
  $: placeholder = $t('askFollowUp');
  $: messageText = $t('askFollowUp');
  async function handleFollowUpSearch() {
    if (query.trim() !== '') {
      //console.log("Before search:", query);
      const originalQuery = query;

      if (query.trim() !== '') {
        const userId = get(user)?.userId;
        const threadId = get(currentSearchThreadId);
        
        if (!threadId) {
          toast.push('No active search thread. Please start a new search.', {
            theme: {
              '--toastBackground': '#F56565',
              '--toastBarBackground': '#C53030'
            }
          });
          return;
        }

        try {
          const result = await performFollowUpSearch(query, userId, threadId,searchType);
          
          if (!result || typeof result !== 'object') {
            throw new Error('Invalid response from performFollowUpSearch');
          }

          const { fullAnswer, searchThreadId, rankedResults } = result;

          if (!fullAnswer || !searchThreadId || !rankedResults) {
            throw new Error('Missing required properties in performFollowUpSearch response');
          }

          history.update(h => {
            const updatedHistory = h.map(thread => {
              if (thread.ThreadId === threadId) {
                return {
                  ...thread,
                  Queries: [...thread.Queries, {
                    query,
                    results: rankedResults,
                    answer: fullAnswer,
                    timestamp: new Date().toISOString()
                  }]
                };
              }
              return thread;
            });
            return updatedHistory;
          });

          dispatch('followUpSearch', { query, fullAnswer, searchThreadId, rankedResults });
        } catch (error) {
          console.error("Error in handleFollowUpSearch:", error);
          dispatch('error', { message: "An error occurred while processing your follow-up search." });
          if (error.response.status === 429) {            
            toast.push(error.response.data.error);
          }
        } finally {
          query = '';
          await tick();
          inputElement.focus();
          console.log("After clearing and tick:", query, "Original:", originalQuery);
        }
      }
    }
  }
</script>

<style>
  .follow-up-search {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .search-bar {
    position: relative;
    display: flex;
    width: 100%;
  }

  input[type="text"] {
    width: 100%;
    padding: 12px 50px 12px 15px;
    font-size: 16px;
    border: 1px solid #333;
    background-color: #ffffff;
    color: #333333;
    border: 1px solid #003476;
  }

  .search-icon {
    position: absolute;
    right: 10px;
    top: 41%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #003476;
    font-size: 28px;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }

  .search-icon:hover {
    color: #ffffff;
  }

  .arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -8px; /* Increased from -2px to -4px to move it higher */
  }
  
  .follow-up-search.darkened input,
  .follow-up-search.darkened .search-icon {
    opacity: 0.5;
    pointer-events: none;
  }
</style>

<div class="follow-up-search" class:darkened>
  <div class="search-bar">
    <input
      bind:this={inputElement}
      type="text"
      bind:value={query}
      placeholder={placeholder}
      on:keydown={(e) => e.key === 'Enter' && handleFollowUpSearch()}
      disabled={darkened}
    />
    <button class="search-icon" on:click={handleFollowUpSearch} aria-label="Search" disabled={darkened}>
      <span class="arrow">→</span>
    </button>
  </div>
</div>
